module.exports = __webpack_public_path__ + "static/media/kubionTopLeft.710cedc5.png";